"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (t, e) {
  for (var i in e) {
    t[i] = e[i];
  }
}(exports, function (t) {
  var e = {};function i(s) {
    if (e[s]) return e[s].exports;var a = e[s] = { i: s, l: !1, exports: {} };return t[s].call(a.exports, a, a.exports, i), a.l = !0, a.exports;
  }return i.m = t, i.c = e, i.d = function (t, e, s) {
    i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: s });
  }, i.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
  }, i.t = function (t, e) {
    if (1 & e && (t = i(t)), 8 & e) return t;if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var s = Object.create(null);if (i.r(s), Object.defineProperty(s, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var a in t) {
      i.d(s, a, function (e) {
        return t[e];
      }.bind(null, a));
    }return s;
  }, i.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return i.d(e, "a", e), e;
  }, i.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, i.p = "", i(i.s = 86);
}({ 0: function _(t, e) {
    t.exports = function () {
      function _class() {
        _classCallCheck(this, _class);
      }

      _createClass(_class, null, [{
        key: "triggerEvent",
        value: function triggerEvent(t, e) {
          var i = void 0;"function" == typeof Event ? i = new Event(e) : (i = document.createEvent("Event"), i.initEvent(e, !0, !0)), t.dispatchEvent(i);
        }
      }, {
        key: "getElementByAttribute",
        value: function getElementByAttribute(t, e) {
          return e ? document.querySelector("[" + t + "=\"" + e + "\"]") : document.querySelector("[" + t + "]");
        }
      }, {
        key: "getElementsByAttribute",
        value: function getElementsByAttribute(t, e) {
          return e ? document.querySelectorAll("[" + t + "=\"" + e + "\"]") : document.querySelectorAll("[" + t + "]");
        }
      }, {
        key: "getElementByAttributeWithinElement",
        value: function getElementByAttributeWithinElement(t, e, i) {
          return i ? t.querySelector("[" + e + "=\"" + i + "\"]") : t.querySelector("[" + e + "]");
        }
      }, {
        key: "isMouseOver",
        value: function isMouseOver(t) {
          return Array.prototype.slice.call(t.parentElement.querySelectorAll(":hover")).filter(function () {
            return t[0] == this;
          }).length > 0;
        }
      }, {
        key: "getElementsByAttributeWithinElement",
        value: function getElementsByAttributeWithinElement(t, e, i) {
          return i ? t.querySelectorAll("[" + e + "=\"" + i + "\"]") : t.querySelectorAll("[" + e + "]");
        }
      }, {
        key: "getElementByClassWithinElement",
        value: function getElementByClassWithinElement(t, e) {
          return t.querySelector("." + e);
        }
      }, {
        key: "maxWidthMobileViewports",
        value: function maxWidthMobileViewports() {
          return 940;
        }
      }, {
        key: "createEvent",
        value: function createEvent(t) {
          var e = void 0;return "function" == typeof Event ? e = new Event(t) : (e = document.createEvent("Event"), e.initEvent(t, !0, !0)), e;
        }
      }, {
        key: "isDesktop",
        value: function isDesktop() {
          return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > this.maxWidthMobileViewports();
        }
      }, {
        key: "isIE11",
        value: function isIE11() {
          return -1 !== navigator.userAgent.indexOf("MSIE") || navigator.appVersion.indexOf("Trident/") > -1;
        }
      }, {
        key: "getKeyCodeOnKeyDownEvent",
        value: function getKeyCodeOnKeyDownEvent(t) {
          var e = void 0;if (null != t) if (void 0 === t.code) switch (t.keyCode) {case 13:
              e = "Enter";break;case 38:
              e = "ArrowUp";break;case 40:
              e = "ArrowDown";break;case 8:
              e = "Backspace";break;case 9:
              e = "Tab";break;case 27:
              e = "Escape";break;case 33:
              e = "PageUp";break;case 34:
              e = "PageDown";break;case 32:
              e = "Space";break;default:
              e = void 0;} else e = t.code;return e;
        }
      }, {
        key: "getKeyboardFocusableElements",
        value: function getKeyboardFocusableElements(t) {
          return [].concat(_toConsumableArray(t.querySelectorAll('a[href], button, input, textarea, iframe, select, details,[tabindex]:not([tabindex="-1"])'))).filter(function (t) {
            return !function (t) {
              return "hidden" === window.getComputedStyle(t).visibility;
            }(t) && !t.hasAttribute("disabled") && !t.getAttribute("aria-hidden");
          });
        }
      }]);

      return _class;
    }();
  }, 2: function _(t, e, i) {
    "use strict";
    var s = i(0),
        a = i.n(s);e.a = function (t, e, i) {
      var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var n = a.a.getKeyboardFocusableElements(e),
          r = n[0],
          u = n[n.length - 1];if (i) {
        if (u.tagName && "IFRAME" === u.tagName) {
          var _t = document.createElement("div");_t.setAttribute("tabindex", "0"), u.parentNode.insertBefore(_t, u.nextSibling);
        }if (r.tagName && "IFRAME" === r.tagName) {
          var _t2 = document.createElement("div");_t2.setAttribute("tabindex", "0"), u.parentNode.insertBefore(_t2, u.nextSibling), r.parentNode.insertBefore(_t2, r);
        }s < 1 && (t.preventDefault(), setTimeout(function () {
          r.focus();
        }, 100)), t.shiftKey ? document.activeElement === r && (t.preventDefault(), u.focus()) : document.activeElement === u && (t.preventDefault(), r.focus());
      }
    };
  }, 86: function _(t, e, i) {
    t.exports = i(87);
  }, 87: function _(t, e, i) {
    "use strict";
    i.r(e), i.d(e, "Chat", function () {
      return r;
    });var s = i(0),
        a = i.n(s),
        n = i(2);
    var r = function () {
      function r(t) {
        _classCallCheck(this, r);

        this.element = t, this.amountTagsChecked, this.box = a.a.getElementsByAttribute(this.attributes.box), this.button = a.a.getElementByAttribute(this.attributes.button), this.close = a.a.getElementByAttribute(this.attributes.close), this.header = a.a.getElementByAttribute(this.attributes.header), this.inputDialog = a.a.getElementByAttribute(this.attributes.input), this.languageNotification = a.a.getElementByAttribute(this.attributes.languageNotification), this.languageSaveButton = a.a.getElementByAttribute(this.attributes.languageSaveButton), this.languageSelector = a.a.getElementByAttribute(this.attributes.languageSelector), this.minimized = a.a.getElementByAttribute(this.attributes.minimized), this.popup = a.a.getElementByAttribute(this.attributes.popup), this.popupHide = a.a.getElementsByAttribute(this.attributes.popupHide), this.popupShow = a.a.getElementByAttribute(this.attributes.popupShow), this.quickSuggestButton, this.saveLanguageButton = a.a.getElementByAttribute(this.attributes.languageSaveButton), this.main = a.a.getElementByAttribute(this.attributes.main), this.settings = a.a.getElementByAttribute(this.attributes.settings), this.settingsButton = a.a.getElementsByAttribute(this.attributes.settingsButton), this.tagsChecked = [], this.tagDialog = a.a.getElementByAttribute(this.attributes.tagsDialog), this.textarea = a.a.getElementByAttribute(this.attributes.textarea), this.deselectButton = a.a.getElementByAttribute(this.attributes.deselectButton), this.submitButton = a.a.getElementByAttribute(this.attributes.submitButton), this.elementIsOpen, this.keystroke = 0, this.addEventHandlers();
      }

      _createClass(r, [{
        key: "addEventHandlers",
        value: function addEventHandlers() {
          var _this = this;

          this.handleHeaderDivider(), this.toggleInputButton(), this.quickSuggestButtonsHandler(), this.tagHandler(), this.close.addEventListener("click", function (t) {
            _this.closeChat(t);
          }), this.minimized.addEventListener("click", function () {
            _this.openChat();
          }), this.userInputToSpeechBubble(), this.toggleSettingsHandler(), this.languageSelectorHandler(), this.popUpHandler(), this.languageSaveButtonHandler(), document.addEventListener("keydown", function (t) {
            _this.handleButtonKeys(t);
          });
        }
      }, {
        key: "handleHeaderDivider",
        value: function handleHeaderDivider() {
          var _this2 = this;

          this.box.forEach(function (t) {
            t.addEventListener("scroll", function () {
              var e = t.scrollTop,
                  i = t.previousElementSibling.classList;e > 1 ? i.remove(_this2.classes.dividerIsHidden) : i.add(_this2.classes.dividerIsHidden);
            });
          });
        }
      }, {
        key: "toggleInputButton",
        value: function toggleInputButton() {
          var _this3 = this;

          this.textarea.addEventListener("input", function () {
            0 === _this3.textarea.value.trim().length ? _this3.button.disabled = !0 : _this3.button.disabled = !1;
          });
        }
      }, {
        key: "openChat",
        value: function openChat() {
          this.minimized && (this.minimized.classList.add(this.classes.displayNone), this.element.classList.remove(this.classes.displayNone), this.elementIsOpen = !0);
        }
      }, {
        key: "closeChat",
        value: function closeChat(t) {
          this.close && this.minimized && (t.preventDefault(), this.element.classList.add(this.classes.displayNone), this.minimized.classList.remove(this.classes.displayNone), this.elementIsOpen = !1, this.keystroke = 0);
        }
      }, {
        key: "quickSuggestButtonsHandler",
        value: function quickSuggestButtonsHandler() {
          var _this4 = this;

          this.quickSuggestButton = a.a.getElementsByAttribute(this.attributes.quickSuggestButton), this.quickSuggestButton && this.quickSuggestButton.forEach(function (t) {
            t.addEventListener("click", function () {
              var e = t.innerHTML,
                  i = t.parentElement;i.removeAttribute(_this4.attributes.quickSuggest), i.setAttribute(_this4.attributes.content, "user"), i.innerHTML = "<div class=\"chat__content chat__content--user speech-bubble speech-bubble--user\">\n            " + e + "\n          </div>", _this4.box.scrollTop = _this4.box.scrollHeight;
            });
          });
        }
      }, {
        key: "getArrayOfSelectedTags",
        value: function getArrayOfSelectedTags(t) {
          if (t.target.checked) this.tagsChecked.push(t.target.value);else {
            var _e = this.tagsChecked.indexOf(t.target.value);-1 !== _e && this.tagsChecked.splice(_e, 1);
          }this.amountTagsChecked = this.tagsChecked.length;
        }
      }, {
        key: "tagHandler",
        value: function tagHandler() {
          var _this5 = this;

          if (this.tags = a.a.getElementByAttribute(this.attributes.tags), !this.tags) return;var t = a.a.getElementsByAttributeWithinElement(this.tags, "data-rs-tags-checkbox"),
              e = a.a.getElementByAttribute(this.attributes.tagsDialogLabel),
              i = e ? e.getAttribute(this.attributes.tagsDialogLabel) : "@tag selected";for (var _s = 0; t[_s]; _s++) {
            t[_s].addEventListener("change", function (t) {
              _this5.getArrayOfSelectedTags(t), _this5.amountTagsChecked > 0 ? (_this5.tagDialog.classList.remove("hidden"), _this5.inputDialog.classList.add("hidden"), _this5.textarea.setAttribute("aria-hidden", !0), _this5.button.setAttribute("aria-hidden", !0), _this5.deselectButton.removeAttribute("aria-hidden"), _this5.submitButton.removeAttribute("aria-hidden"), e.innerText = i.replace("@tag", _this5.amountTagsChecked)) : (_this5.tagDialog.classList.add("hidden"), _this5.inputDialog.classList.remove("hidden"), _this5.textarea.removeAttribute("aria-hidden"), _this5.button.removeAttribute("aria-hidden"), _this5.deselectButton.setAttribute("aria-hidden", !0), _this5.submitButton.setAttribute("aria-hidden", !0));
            });
          }this.handleTagDialogButtons();
        }
      }, {
        key: "handleTagDialogButtons",
        value: function handleTagDialogButtons() {
          var _this6 = this;

          var t = a.a.getElementsByAttributeWithinElement(this.tags, "data-rs-tags-checkbox");this.deselectButton.addEventListener("click", function () {
            _this6.tagsChecked = [], t.forEach(function (t) {
              t.checked && t.click();
            }), t[0].focus();
          }), this.submitButton.addEventListener("click", function () {
            var t = _this6.tagsChecked.join(", ");_this6.tags.setAttribute(_this6.attributes.content, "user"), _this6.tags.removeAttribute(_this6.attributes.tags), _this6.tags.innerHTML = "<div class=\"chat__content chat__content--user speech-bubble speech-bubble--user\">\n            " + t + "\n          </div>", _this6.tagDialog.classList.add("hidden"), _this6.inputDialog.classList.remove("hidden"), _this6.box.scrollTop = _this6.box.scrollHeight, _this6.submitButton.setAttribute("aria-hidden", !0), _this6.deselectButton.setAttribute("aria-hidden", !0), _this6.textarea.removeAttribute("aria-hidden"), _this6.button.removeAttribute("aria-hidden"), _this6.textarea.focus();
          });
        }
      }, {
        key: "createSpeechBubble",
        value: function createSpeechBubble(t) {
          if ("click" === t.type || "Enter" === t.key) {
            var _t3 = this.textarea.value,
                _e2 = a.a.getElementByAttribute(this.attributes.quickSuggest);_e2 && _e2.remove(), this.tags && this.tags.remove();var _i = a.a.getElementByAttribute(this.attributes.box, "chat");if (_i.innerHTML = _i.innerHTML += "<div class='chat-content__wrapper' data-rs-chat-content='user'><div class=\"chat__content chat__content--user speech-bubble speech-bubble--user\">\n      " + _t3 + "</div></div>", _i.lastElementChild) {
              "bot" === _i.lastElementChild.getAttribute(this.attributes.content) && _i.lastElementChild.classList.add("chat-content__wrapper--first");
            }this.textarea.value = "", this.textarea.style.height = "auto", this.button.disabled = !0, _i.scrollTop = _i.scrollHeight;
          }
        }
      }, {
        key: "userInputToSpeechBubble",
        value: function userInputToSpeechBubble() {
          var _this7 = this;

          this.button.addEventListener("click", function (t) {
            _this7.createSpeechBubble(t), _this7.textarea.focus();
          }), this.textarea.addEventListener("keydown", function (t) {
            _this7.createSpeechBubble(t), _this7.textarea.focus();
          });
        }
      }, {
        key: "toggleSettingsHandler",
        value: function toggleSettingsHandler() {
          var _this8 = this;

          this.settingsButton.forEach(function (t) {
            t.addEventListener("click", function () {
              _this8.openAndCloseSettings();
            });
          });
        }
      }, {
        key: "languageSelectorHandler",
        value: function languageSelectorHandler() {
          var _this9 = this;

          this.languageSelector.addEventListener("change", function () {
            "" !== _this9.languageSelector.value ? (_this9.languageSaveButton.removeAttribute("disabled"), _this9.languageNotification.classList.remove("display-none")) : (_this9.languageSaveButton.setAttribute("disabled", "disabled"), _this9.languageNotification.classList.add("display-none"));
          });
        }
      }, {
        key: "popUpHandler",
        value: function popUpHandler() {
          var _this10 = this;

          var t = [];this.popupShow.addEventListener("click", function () {
            return _this10.popup.classList.add("is-active"), t = a.a.getKeyboardFocusableElements(_this10.settings), t.forEach(function (t) {
              t.setAttribute("aria-hidden", !0);
            }), t;
          }), this.popupHide.forEach(function (e) {
            e.addEventListener("click", function () {
              _this10.popup.classList.remove("is-active"), t.forEach(function (t) {
                return t.removeAttribute("aria-hidden");
              }), _this10.settingsButton.focus();
            });
          });
        }
      }, {
        key: "languageSaveButtonHandler",
        value: function languageSaveButtonHandler() {
          var _this11 = this;

          this.saveLanguageButton.addEventListener("click", function () {
            a.a.getElementByAttribute(_this11.attributes.box, "chat").innerHTML = "", _this11.openAndCloseSettings();
          });
        }
      }, {
        key: "openAndCloseSettings",
        value: function openAndCloseSettings() {
          var _this12 = this;

          var t = this.settings.classList;t.contains(this.classes.isActive) ? (this.main.classList.remove("hidden"), t.remove(this.classes.isActive), this.settingsButton[0].focus()) : (t.add(this.classes.isActive), setTimeout(function () {
            _this12.main.classList.add("hidden");
          }, 500));
        }
      }, {
        key: "handleButtonKeys",
        value: function handleButtonKeys(t) {
          if (null != t) switch (a.a.getKeyCodeOnKeyDownEvent(t)) {case "Escape":
              this.elementIsOpen && this.closeChat(t);break;case "Tab":
              var _e3 = this.main.classList.contains("hidden") ? this.settings : this.main;Object(n.a)(t, _e3, this.elementIsOpen, this.keystroke), this.elementIsOpen && this.keystroke++;}
        }
      }, {
        key: "classes",
        get: function get() {
          return { dividerIsHidden: "divider--is-hidden", displayNone: "display-none", isActive: "is-active" };
        }
      }, {
        key: "attributes",
        get: function get() {
          return { box: "data-rs-chat-box", button: "data-rs-chat-button", close: "data-rs-chat-close", main: "data-rs-chat-main", content: "data-rs-chat-content", deselectButton: "data-rs-chat-tags-deselect-button", header: "data-rs-chat-header", input: "data-rs-chat-input", languageNotification: "data-rs-chat-language-notification", languageSaveButton: "data-rs-chat-language-save-button", languageSelector: "data-rs-chat-language-selector", minimized: "data-rs-chat-minimized", popup: "data-rs-chat-popup", popupHide: "data-rs-chat-popup-hide", popupShow: "data-rs-chat-popup-show", quickSuggest: "data-rs-chat-quick-suggest", quickSuggestButton: "data-rs-chat-quick-suggest-button", saveLanguageButton: "data-rs-chat-save-language", settings: "data-rs-chat-settings", settingsButton: "data-rs-chat-settings-button", submitButton: "data-rs-chat-tags-submit-button", tags: "data-rs-chat-tags", tagsDialog: "data-rs-chat-tags-dialog", tagsDialogLabel: "data-rs-chat-tags-dialog-label", textarea: "data-rs-chat-textarea" };
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[data-rs-chat]";
        }
      }]);

      return r;
    }();
  } }));